import { useFormatter, useTranslations } from 'next-intl';
import { MetaDefault } from '@terra/ui-design-system';
import { Box } from '@terra/ui-styled-system';
import type { PortalTarget } from '../../../store/projectStore';
import { HighlightedTargetName } from './HighlightedTargetName';
import { LauncherRowButton } from './LauncherRowButton';
import type { LauncherTargetItem } from './launcher-targets';

type LauncherTargetRowProps = {
  item: LauncherTargetItem;
  query: string;
  isOpen: boolean;
  onOpen: (target: PortalTarget) => void;
};

export function LauncherTargetRow({
  item: { target, icon: Icon, recent },
  query,
  isOpen,
  onOpen,
}: LauncherTargetRowProps) {
  const t = useTranslations('proxy.workspaces');
  const formatter = useFormatter();
  const openedLabel = recent
    ? t('openedOn', {
        date: formatter.dateTime(new Date(recent.lastOpenedAt), {
          month: 'short',
          day: 'numeric',
        }),
      })
    : null;
  const statusLabel = isOpen ? t('currentlyOpen') : openedLabel;

  return (
    <LauncherRowButton
      ariaLabel={t('openTarget', { name: target.name })}
      onClick={() => onOpen(target)}
    >
      <Box color="fg.neutral.muted" display="flex" flexShrink={0}>
        <Icon size={16} />
      </Box>
      <HighlightedTargetName name={target.name} query={query} />
      {statusLabel && (
        <MetaDefault color="fg.neutral.muted" flexShrink={0}>
          {statusLabel}
        </MetaDefault>
      )}
    </LauncherRowButton>
  );
}
